import imageUrlBuilder from "@sanity/image-url"
import { DateTime } from "luxon"

import sanityClient from "#/providers/SanityStudioProvider"

const builder = imageUrlBuilder(sanityClient)

export const getGreetingMessage = (dateTime: DateTime = DateTime.local()) => {
  const { hour } = dateTime

  if (hour >= 4 && hour < 12) {
    return "☀️ Good morning"
  }

  if (hour >= 12 && hour < 18) {
    return "👋 Good afternoon"
  }

  return "🌙 Good evening"
}

export const buildUrlForSanityCmsImage = (source?: {
  asset?: { _ref?: string; url?: string }
}): string => {
  // eslint-disable-next-line no-underscore-dangle
  if (!source?.asset?.url && !source?.asset?._ref) {
    return ""
  }

  if (source.asset.url) {
    return source.asset.url
  }

  return builder.image(source).url()
}

export const isEmailValid = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
